import { dataPenWriteSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPenWriteSolid = /*#__PURE__*/createIcon(dataPenWriteSolid)
export default IconPenWriteSolid
